var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Gmail",
    role: "img",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: "15%",
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M120 392V151.075h272V392"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.05,
    d: "M256 285L120 392l-4-212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d54c3f",
    d: "M120 392H97c-12 0-22-10-22-23V143h45z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.08,
    d: "M317 392h77V159H82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M97 121h318L256 234"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b63524",
    d: "M392 392h23c12 0 22-10 22-23V143h-45z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#de5145",
    strokeLinecap: "round",
    strokeWidth: 44,
    d: "M97 143l159 115 159-115"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail-icon.d0b22536f5071df9a962a2afea04171b.svg";
export { ForwardRef as ReactComponent };